import React, {useState, useEffect, useContext} from 'react';
import { Context } from '../../state/context';
import { useHistory } from "react-router-dom";
import useFetch from "../../api/fetch";
import queryString from "query-string";
import TranslationKeysExport from '../translation-keys-export/translation-keys-export.component';
import KeyItemStatus from '../key-item-status/key-item-status.component';
import {PLATFORM_ICONS, PLATFORM_NAMES} from '../../enums/platforms';
import { STATUS_LIST } from "../../enums/key-status-list";

import useGetCategories from '../../api/categories';
import useGetTags from '../../api/tags';

import './translation-keys-left-panel.styles.scss';



export default function TranslationKeysLeftPanel({ keys }) {
    const { state, dispatch } = useContext(Context);

    const getCategories = useGetCategories();
    const getTags = useGetTags();
    const fetch = useFetch();
    const history = useHistory();

    const [search, setSearch] = useState("");
    const [platforms, setPlatforms] = useState({
        'platform::vr': 'platform::vr',
        'platform::android': 'platform::android',
        'platform::ios': 'platform::ios',
        'platform::web': 'platform::web',
        'platform::marketing': 'platform::marketing',
    });
    const [platformNone, setPlatformNone] = useState(true);
    const [filteredKeys, setFilteredKeys] = useState([]);
    const [permalinkKey, setPermalinkKey] = useState("");
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState(0);
    const [tags, setTags] = useState([]);
    const [tag, setTag] = useState("");
    const [csv, setCsv] = useState([]);
    const [importLoading, setImportLoading] = useState(false);
    const [statuses, setStatuses] = useState({});

    useEffect(() => {
        const queryValues = queryString.parse(window.location.search);
        if(queryValues.key && queryValues.key.length > 0) {
            setPermalinkKey(queryValues.key);
        }

        if(state.categories.length < 1) {
            (async () => {
                const cats = await getCategories();
                dispatch({ type: 'SET_CATEGORIES', categories: cats });
            })();
        }

        if(state.tags.length < 1) {
            (async () => {
                const t = await getTags();
                dispatch({ type: 'SET_TAGS', tags: t });
            })();
        }
    }, []);

    useEffect(() => {
        setCategories(state.categories);
    }, [state.categories]);

    useEffect(() => {
        setTags(state.tags);
    }, [state.tags]);

    useEffect(() => {
        if(permalinkKey.length > 0 && keys.length > 0) {
            const selectedKey = keys.find(key => key.text.toLowerCase() === permalinkKey.toLowerCase());
            if(selectedKey) {
                dispatch({ type: 'SET_ACTIVE_TRANSLATION_KEY', activeTranslationKey: selectedKey });
            }
        }
        setFilteredKeys(keys);
    }, [keys, permalinkKey]);

    useEffect(() => {
        if (csv.length > 0) {
            setImportLoading(true);
            handleImport(csv[0]);
        }
    }, [csv]);

    useEffect(() => {
        const filtered = keys
                        .filter(
                            ({ all_tags }) => {
                              // If there is no platform tag set, and the platformNone filter is active, return true
                                if (platformNone && all_tags.filter((p) => Object.keys(PLATFORM_NAMES).includes(p)).length === 0) {
                                  return true;
                                }
                                if (Object.keys(platforms).length > 0) {
                                    return all_tags.filter((p) => Object.keys(platforms).includes(p)).length > 0;
                                }

                                return false;
                            }
                        )
                        .filter(({ all_categories }) => {
                            if (category > 0) {
                                return all_categories.filter((cat) => parseInt(category) === cat).length !== 0
                            }

                            return true;
                        })
                        .filter(({ all_tags }) => {
                            if (!tag || tag.length == 0)
                                return true;

                            return all_tags.filter((t) => tag === t).length !== 0
                        })
                        .filter(({ text, target }) => text.toLowerCase().includes(search.toLowerCase()) || (target && target.toLowerCase().includes(search.toLowerCase())))
                        .filter(
                            ({ key_general_status }) => {
                                if(Object.keys(statuses).length > 0) {
                                    if (key_general_status != null) {
                                        return statuses[key_general_status.toString()]
                                    }
                                } else if(Object.keys(statuses).length === 0) {
                                    return true;
                                }

                                return false;
                            }
                        );
        setFilteredKeys(filtered);
    }, [search, platforms, platformNone, category, tag, statuses]);

    const handleStatusChange = (e) => {
        let value = e.target.value.toString();

        if (e.target.checked) {
            statuses[value] = STATUS_LIST[value];
        } else {
            delete statuses[value];
        }
        setStatuses({ ...statuses });
        console.log(statuses);
    }

    const handlePlatformChange = (e) => {
        let value = e.target.value.toString();

        if (e.target.checked) {
            platforms[value] = value;
        } else {
            delete platforms[value];
        }
        setPlatforms({ ...platforms });
    }

    var handleImport = async (csvFile) => {

        const data = new FormData();
        data.append('csv', csvFile, csvFile.name);

        const result = await fetch(`/api/key/import`, {
            method: "POST",
            body: data
        }).then(x => x.json());

        if (result.success) {
            document.getElementById('keys-import').value = null;
            setCsv([]);
            setImportLoading(false);
            dispatch({ type: 'SET_REFRESH_TRANSLATIONS', translationStatus: true });
        }
    }

    var highlightedText = (text) => {
        if (search.length < 1) {
            return text;
        }

        var index = text.toLowerCase().indexOf(search.toLowerCase());

        if (index < 0) {
            return text;
        }

        var newText = "";
        var originalText = text;
        while (originalText.length > 0) {
            if (index >= 0) {
                newText += originalText.substring(0, index) + '<span className="text-warning">' + originalText.substring(index, index + search.length) + '</span>';
                originalText = originalText.substring(index + search.length);
            } else {
                newText += originalText;
                originalText = '';
            }

            index = originalText.toLowerCase().indexOf(search.toLowerCase());
        }

        return newText;
    }

    const keyClick = (key) => {
        history.push({
            path: window.location.pathname,
            search: `?key=${key.text}`
        });
        dispatch({ type: 'SET_ACTIVE_TRANSLATION_KEY', activeTranslationKey: key });
    };

    return (
        <div className="d-flex flex-column col">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <h6>Search key</h6>
                <div className="d-flex align-items-center justify-content-end">
                    <a className="btn btn-mondly btn-blue mr-3" href="#export-translations" data-toggle="modal">Export</a>
                    <div className="form-group m-0 p-0">
                        <input type="file" className="d-none" id="keys-import"  onChange={e => setCsv(e.currentTarget.files)} disabled={importLoading}/>
                        <label htmlFor={'keys-import'} className="btn btn-mondly btn-blue mr-3 mb-0">{importLoading ? 'Importing...' : 'Import'}</label>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="input-group search-field">
                    <input className={"form-control shadow-none border-right-0"}
                        placeholder={"Search"}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)} />
                    <div className="input-group-append">
                        <span className={"input-group-text bg-transparent border-left-0"}><i className="fas fa-search"></i></span>
                    </div>
                </div>
                <div className="d-flex ml-5">
                    {Object.keys(PLATFORM_ICONS).map((p, index) => (
                        <div key={index} className={"form-check-inline form-check platform-check-container"}>
                            <input className="form-check-input platform-check d-none" type="checkbox"
                                id={`platform-${p}`} onChange={handlePlatformChange} value={p} checked={Object.keys(platforms).includes(p)}/>
                            <label className="form-check-label platform-label cursor-pointer text-light-gray"
                                data-toggle="tooltip" data-placement="top" title={PLATFORM_NAMES[p]}
                                htmlFor={`platform-${p}`}>
                                <i className={`m-1 ${PLATFORM_ICONS[p]}`} />
                            </label>
                        </div>
                    ))}
                  <div className={"form-check-inline form-check platform-check-container"}>
                    <input className="form-check-input platform-check d-none" type="checkbox"
                           id="platform-none" onChange={(e) => {setPlatformNone(!platformNone)}} checked={platformNone}/>
                    <label className="form-check-label platform-label cursor-pointer text-light-gray"
                           data-toggle="tooltip" data-placement="top" title="No platform"
                           htmlFor="platform-none">
                      <i className="m-1 fas fa-question" />
                    </label>
                  </div>
                </div>
            </div>
            <div className="row mb-3">
                <div className="col-6">
                    <select className="custom-select" onChange={(e) => setCategory(e.target.value)}>
                        <option value="0" selected>All categories</option>
                        {categories.map((cat, index) => (
                            <option value={cat.id} key={index}>{cat.name}</option>
                        ))}
                    </select>
                </div>
                <div className="col-6">
                    <select className="custom-select" onChange={(e) => setTag(e.target.value)}>
                        <option value="" selected>All tags</option>
                        {tags.map((t, index) => (
                            <option value={t.name} key={index}>{t.name}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={`d-flex`}>
                {Object.keys(STATUS_LIST)
                .map((status, index) => (
                    <span className="mr-2" key={index}>
                        <input type="checkbox" onChange={handleStatusChange} value={status} className={"d-none status-checkbox"} id={`status-checkbox-${index}`} />
                        <label className={"d-inline-flex align-items-center py-1 status-label cursor-pointer"} htmlFor={`status-checkbox-${index}`}>
                            <KeyItemStatus status={status} />
                            <span className="ml-1">{STATUS_LIST[status].text}</span>
                        </label>
                    </span>

                ))}
            </div>
            <div className="keys-column flex-fill">
                {filteredKeys.length > 0 ? filteredKeys.map((key, index) => (
                    <div
                        className={`d-flex align-items-center justify-content-between key-item p-3 mb-2 ${state.activeTranslationKey && key.id === state.activeTranslationKey.id ? 'active' : ''}`}
                        onClick={() => keyClick(key)}
                        key={index}>
                            <div className="d-flex flex-column">
                                <span className={"translation-key"} dangerouslySetInnerHTML={{ __html: highlightedText(key.text)}}></span>
                                <span className="translation-source" dangerouslySetInnerHTML={{ __html: highlightedText(key.source_string)}}></span>
                            </div>
                            <div className="d-flex align-items-center">
                                <span className="text-muted">({key.translated_strings}/{key.total_strings})</span>
                                <KeyItemStatus className="ml-2" status={key.key_general_status} />
                                <i className="d-inline-block ml-3 fas fa-chevron-right"></i>
                            </div>

                    </div>
                )) : <div>No results</div>}
            </div>

            <TranslationKeysExport />
        </div>
    )
}
